import { render, staticRenderFns } from "./EventOptions.vue?vue&type=template&id=b790548a"
import script from "./EventOptions.vue?vue&type=script&lang=js"
export * from "./EventOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports